import React, {useRef} from 'react';
import IconPanelContainer from "../Containers/IconPanelContainer";
import SubsidiaryInformationSection from "../Sections/SubsidiaryInformationSection";
import AddButton from "../../Atoms/Buttons/AddButton";
import SubsidiaryItem from "../../Molecules/Items/SubsidiaryItem";
import SubsidiaryModal from "../Modals/SubsidiaryModal";

const SubsidiaryPanel = () => {
  const modal = useRef()

  const handleOpenModal = () => {
    modal.current.openModal()
  }

  return (
    <div>
      <IconPanelContainer
        icon="home"
        title="Sucursales"
      >
        <SubsidiaryInformationSection isMainSubsidiary/>
        <div className="ed-grid s-gap-1 rows-gap">
          <AddButton
            onClick={handleOpenModal}
            text="Agrega una sucursal"
          />
          <SubsidiaryItem isMain isSelected />
          <SubsidiaryItem/>
          <SubsidiaryItem/>
        </div>
      </IconPanelContainer>

      <SubsidiaryModal
        ref={modal}
      />
    </div>
  );
};

export default SubsidiaryPanel;
